import React from "react";
import ReactDOM from "react-dom";
import "typeface-roboto";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";

import App from "./App";
import registerServiceWorker from "./registerServiceWorker";

ReactDOM.render(<App />, document.getElementById("root"));
registerServiceWorker();
